import { DATE_SUBTYPES, transformDate } from "../../helpers/dateNormalization"

export function getMatrixTypes() {
  return ["matrix", "matrixcheckbox"]
}

export function isMatrixQuestionType(type) {
  return getMatrixTypes().includes(type)
}

export function formatCompletedDateToLocaleString(date) {
  let dateObj = transformDate(date, "date", DATE_SUBTYPES.DATE, true)

  if (dateObj && dateObj.isValid) {
    return dateObj.toLocaleString()
  } else {
    return date
  }
}
